import { Reveal } from "../components/Reveal";
import { AudioPlayer } from "../components/AudioPlayer";
import { WORLDS } from "../data/worlds";

const concepts = [
  { t: "Hören", d: "Motive und Begriffe wiederentdecken.", c: "#3A7BD5" },
  { t: "Mitsingen", d: "Einfache Wörter und wiederkehrende Passagen.", c: "#E5A93C" },
  { t: "Bewegen", d: "Klatschen, wippen und gemeinsam mitmachen.", c: "#4A8B5D" },
];

export const Music = () => (
  <section className="py-24 sm:py-32" style={{ background: "var(--paper-deep)" }} data-testid="music-section">
    <div className="max-w-4xl mx-auto px-5 lg:px-8">
      <Reveal className="text-center mb-6">
        <p className="eyebrow-label mb-5">Der VisualMA Lernsong</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-6">
          Eine Lernwelt, die auch <em style={{ color: "var(--terra)" }}>klingt.</em>
        </h2>
        <p className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed max-w-xl mx-auto">
          Zu Kleine Welt, große Farben gehört ein eigener VisualMA Lernsong. Die Inhalte des Buches
          werden musikalisch aufgegriffen, damit Kinder gemeinsam mitsingen, klatschen und sich
          bewegen können.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="max-w-xl mx-auto mt-12 mb-4">
        <AudioPlayer title={WORLDS[0].song.title} src={WORLDS[0].song.url} />
      </Reveal>
      <Reveal delay={0.14} className="text-center mb-12">
        <p className="text-xs text-[color:var(--ink-muted)]">
          Kurze öffentliche Hörprobe – der vollständige Lernsong ist Teil des Lernpakets.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {concepts.map((l, i) => (
          <Reveal key={l.t} delay={0.12 + i * 0.08}>
            <div className="card-soft !rounded-2xl p-6 text-center h-full" data-testid={`music-label-${l.t.toLowerCase()}`}>
              <p className="text-[11px] uppercase tracking-[0.22em] font-semibold mb-2.5" style={{ color: l.c }}>
                {l.t}
              </p>
              <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed">{l.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
